var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 30 27",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.07142857 15.5357143h27.85714283c.5917634 0 1.0714286-.4796652 1.0714286-1.0714286v-2.6785714c0-.5917634-.4796652-1.0714286-1.0714286-1.0714286h-27.85714283c-.59176339 0-1.07142857.4796652-1.07142857 1.0714286v2.6785714c0 .5917634.47966518 1.0714286 1.07142857 1.0714286z",
    fill: "#4cd964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.07142857 26.25h27.85714283c.5917634 0 1.0714286-.4796652 1.0714286-1.0714286v-2.6785714c0-.5917634-.4796652-1.0714286-1.0714286-1.0714286h-27.85714283c-.59176339 0-1.07142857.4796652-1.07142857 1.0714286v2.6785714c0 .5917634.47966518 1.0714286 1.07142857 1.0714286z",
    fill: "#007aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.07142857 4.82142857h27.85714283c.5917634 0 1.0714286-.47966518 1.0714286-1.07142857v-2.67857143c0-.59176339-.4796652-1.07142857-1.0714286-1.07142857h-27.85714283c-.59176339 0-1.07142857.47966518-1.07142857 1.07142857v2.67857143c0 .59176339.47966518 1.07142857 1.07142857 1.07142857z",
    fill: "#fc0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.b255913d.svg";
export { ForwardRef as ReactComponent };